module.exports = __webpack_public_path__ + "static/img/menu4.cd0d9862.png";